import type { MailingStatus } from '~/admin/shared/api/client/mailing/dto';

export const MAILING_STATUS_LABELS: Record<MailingStatus, string> = {
  draft: 'Черновик',
  scheduled: 'Запланирована',
  queued: 'В очереди',
  sending: 'Отправляется',
  sent: 'Отправлена',
  failed: 'Ошибка',
};

export const MAILING_STATUS_TONES: Record<
  MailingStatus,
  'green' | 'yellow' | 'gray' | 'red'
> = {
  draft: 'gray',
  scheduled: 'yellow',
  queued: 'yellow',
  sending: 'yellow',
  sent: 'green',
  failed: 'red',
};

export const getMailingStatusLabel = (status?: MailingStatus | null) =>
  status ? (MAILING_STATUS_LABELS[status] ?? status) : 'Черновик';

export const getMailingStatusTone = (status?: MailingStatus | null) =>
  status ? (MAILING_STATUS_TONES[status] ?? 'gray') : 'gray';

/*
 * Статусы, при которых рассылка уже ушла в отправку — редактировать нельзя.
 * draft и failed остаются редактируемыми (failed — чтобы исправить и переотправить).
 */
export const MAILING_READONLY_STATUSES: MailingStatus[] = [
  'queued',
  'sending',
  'sent',
];

export const isMailingReadonly = (status?: MailingStatus | null) =>
  Boolean(status && MAILING_READONLY_STATUSES.includes(status));

export const hasMailingStats = (status?: MailingStatus | null) =>
  Boolean(status && ['sent'].includes(status));
